import React from 'react'

interface IProps {
    text?: string;
}

export const LoadingSpinner: React.FC<IProps> = ({ text }) => {
    return (
        <div className="d-flex justify-content-center align-items-center flex-column my-5">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            {text && <div className="mt-2 text-muted">{text}</div>}
        </div>
    )
}
